var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricingSmallBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1281,
    height: 795,
    viewBox: "0 0 1281 795",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 795,
    transform: "translate(0.400391)",
    fill: "#38C99F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5125_8183",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1281,
    height: 795
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 795,
    transform: "translate(0.400391)",
    fill: "#38C99F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5125_8183)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 596.811,
    height: 509.754,
    rx: 63,
    transform: "matrix(0.674156 -0.738589 0.674156 0.738589 1167.4 458.798)",
    fill: "#BEFFEC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 397.135,
    height: 605.008,
    rx: 63,
    transform: "matrix(0.568241 -0.822862 0.568241 0.822862 -461 15.7876)",
    fill: "#58E3BA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 596.811,
    height: 509.754,
    rx: 63,
    transform: "matrix(0.674156 -0.738589 0.674156 0.738589 1167.4 614.371)",
    fill: "#58E3BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingSmallBg);
export default __webpack_public_path__ + "static/media/pricing_small_bg.551a476675adf6ce74ebbf98d23d7b2f.svg";
export { ForwardRef as ReactComponent };